
import { post } from '../api/api'
import { getDateWithFormat, logError } from '../utils/utils'
import { addSingleProduct, getAllOfTable, removeAllProducts, getSingleProduct, updateProduct, add, addSingleAccountProduct, updateAccountProduct, getSingleAccountProduct, removeAllAccountProducts, removeCollection, addSingleInmate, addInmateSubmitFormealPeriod, getAllOfTableWithKeys, removeInmateSubmitData } from './localbase'
import { ApiUrls } from '../api/baseURL'
import { format } from 'date-fns'
import { metaDataConstants } from '../utils/Constants/constants-en'

export const saveProductOffline = (productObject) => {
  return addSingleProduct(productObject)
}

//adds scanned inmate data in index db
export const saveInmateOffline = (productObject) => {
  return addSingleInmate(productObject)
}

//adds submitted inmate data in index db
export const submitInmateOffline = (id, patientIdString) => {
  return addInmateSubmitFormealPeriod(id, patientIdString)
}

//updates already scanned product in index db
export const updateProductOffline = (productObject) => {
  const key = productObject.ProductName
  return updateProduct(key, productObject)
}

//fetches products from index db in offline mode after scan
export const getProductOffline = (id) => {
  return getSingleProduct(id).then((res) => {
    if (res) {
      return res
    } else {
      return null
    }
  }).catch(() => { return null })
}

//fetch all data from Products table in index db
export const getAllProductOffline = () => {
  return getAllOfTable('Products')
}

//fetch all data from InmateSubmit table in index db
export const getAllInmateSubmitOffline = async () => {
  return getAllOfTableWithKeys('InmateSubmit')
}

//after comming online, if data is present, push inmate data to backend
export const initPushInmates = async () => {
  const res = await getAllInmateSubmitOffline()
  if (res && res.length > 0) {
    if (res.length > 0) {
      pushInmateList(res)
        .then(() => {
          console.log("pushed inmate data")
        })
        .catch((err) => {
          console.log("on push lead error", err)
        })
    }
  } 
};

//after comming online, if data is present, push product data to backend
export const initPushProduct = () => {
  return getAllProductOffline().then((res) => {
    if (res && res.length > 0) {
      const last3Again = res;
      if (res.length > 0) {
        pushProductList(last3Again)
          .then(() => {
            console.log("pushed product data");
          })
          .catch((err) => {
            console.log("on push lead error", err);
          });
      } 
    }
  });
};

export const initPushAccountProduct = () => {
  return getAllAccountProductOffline().then((res) => {
    if (res && res.length > 0) {
      const last3Again = res;
      if (res.length > 0) {
        pushAccountProductList(last3Again[0].accountProducts)
          .then((result) => {
            console.log("pushed product data");
          })
          .catch((err) => {
            console.log("on push lead error", err);
          });
      }
    }
  });
};

//push logs on sync
export const initPushLogs = () => {
  return getAllOfTable("OfflineErrorLog").then((res) => {
    if (res.length > 0) {
      console.log(res);
      let payloadString = "";
      res.forEach(item => {
        payloadString += "$ERR_LOG$ : " + item.ERR + " "
      });
      logError(payloadString).then((res) => {
        console.log(res)
        res?.data == "Success" && removeCollection("OfflineErrorLog")
      })
    }
  })
}

const deletePushedProducts = (leads) => {
  deleteLeads(leads).then((result) => {
    console.log("::: deletePushedProducts :::", result);
  });
};

const getPreviousQuantity = async () => {
  const res = await getAllProductOffline()
  if (res && res.length > 0) {
    const payload = {
    }
    const response = await post(ApiUrls().OFFLINE_PREVIOUS_QUANTITY, payload)
      .catch(function (error) {
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      const dataObject = {
        previousQuantityDetails: response?.data.result,
      };
      add("PreviousQuantityDetails", dataObject)
        .then((res) => {
          window.location.reload()
        })
        .catch((err) => console.log(err));
    }
  }
};

//api call for inmate push
const pushInmateList = async (inmateData) => {
  inmateData.forEach(async obj => {

    const payload = {
      patientIds: obj.data.inmateIds,
      serveTimeId: obj.key,
      orderDate: getDateWithFormat(metaDataConstants.yearMonthDateFormat)
    }
    const response = await post(ApiUrls().INMATE_SCANNING_ORDER, payload)
      .catch(function (error) {
        // Handle errors here
        console.error("Error:", error);
      });
      if (response.status === 200) {
        console.log("Inmate data submitted successfully")
        removeInmateSubmitData()
      } else {
        console.log("Something went wrong while submitting inmate data")
      }
  })
}

const getPreviousQuantityAccoutProducts = async () => {

  const payload = {
    "IsActive": 1,
    "accountId": "",
    "workflowModuleKey": "INVENTORY_COUNT_FILL",
    "moduleKey": 1,
    "masterId": 0,
    "timeOffset": -330,
    "isIncludePosted": 0,
    "take": 1000,
    "skip": 0,
    "page": 1,
    "pageSize": 1000
  };

  const response = await post(ApiUrls().PHYSICAL_INVENTORYCHECK_OFFLINE, payload)
    .catch(function (error) {

    });
  if (response?.status === 200) {
    const dataObject = {
      physicalInventoryDetails: response?.data.result,
    };
    add("PhysicalInventoryDetails", dataObject)
      .then(() => {
        window.location.reload()
      })
      .catch((err) => console.log(err));
  }
};

//api call for product push
export const pushAccountProductList = async (productData) => {
  for (let i = 0; i < productData.length; i++) {
    const ProductDetails = [
      {
        productId: productData[i].productId,
        uomId1: productData[i].uomId1 == null ? 0 : productData[i].uomId1,
        uomEnteredStock1: productData[i].uomEnteredStock1,
        uomId2: productData[i].uomId2 == null ? 0 : productData[i].uomId2,
        uomEnteredStock2: productData[i].uomEnteredStock2,
        uomId3: productData[i].uomId3 == null ? 0 : productData[i].uomId3,
        uomEnteredStock3: productData[i].uomEnteredStock3,
        uomId4: productData[i].uomId4 == null ? 0 : productData[i].uomId4,
        uomEnteredStock4: productData[i].uomEnteredStock4,
        unitTotalQuantity: productData[i].unitTotalQuantity,
        unitTotalQuantityUOMId: productData[i].unitTotalQuantityUOMId,
        isConversionMissMatch: productData[i].isConversionMissMatch,
        locationStorageId: productData[i].locationStorageId,
      },
    ];
    const payload = {
      AccountId: productData[i].AccountId,
      InventoryCheckAccountId: productData[i].InventoryCheckAccountId,
      IsLoadFromPrevious: productData[i].IsLoadFromPrevious,
      IsSaveOnNext: productData[i].IsSaveOnNext,
      ProductDetails,
    };

    const res = await post(ApiUrls().UPDATE_ACCOUNT_INVENTORY_FOR_OFFLINE, payload)
    if (res.status === 200) {
      removeAllAccountProducts();
    } else {
      console.log("Something went wrong while updating the product")
    }
  }
  localStorage.setItem("isofflineaccproductsadded", false)
  removeAllAccountProducts();
  getPreviousQuantityAccoutProducts()
};
export const pushProductList = async (productData) => {
  for (let i = 0; i < productData.length; i++) {
    const payload = {
      ProductInventoryXml: `<root><node><Header><InventoryCheckId>${productData[i].InventoryCheckId}</InventoryCheckId><LocationStorageId>${productData[i].LocationStorageIds}</LocationStorageId><ProductId>${productData[i].ProductId}</ProductId><UOMId1>${productData[i].UOMId1
        }</UOMId1><UOMEnteredStock1>${productData[i].UOMEnteredStock1
        }</UOMEnteredStock1><UOMId2>${productData[i].UOMId2}</UOMId2><UOMEnteredStock2>${productData[i].UOMEnteredStock2
        }</UOMEnteredStock2><UOMId3>${productData[i].UOMId3}</UOMId3><UOMEnteredStock3>${productData[i].UOMEnteredStock3
        }</UOMEnteredStock3><UOMId4>${productData[i].UOMId4 == null ? 0 : productData[i].UOMId4}</UOMId4><UOMEnteredStock4>${productData[i].UOMEnteredStock4
        }</UOMEnteredStock4><UOMId6>${productData[i].UOMId6 == null ? 0 : productData[i].UOMId6}</UOMId6><UOMEnteredStock6>${productData[i].UOMEnteredStock6
        }</UOMEnteredStock6><UnitTotalQuantityUOMId>${productData[i].UnitTotalQuantityUOMId}</UnitTotalQuantityUOMId><UnitTotalQuantity>${productData[i].UnitTotalQuantity}</UnitTotalQuantity><AccountId>${productData[i].AccountId}</AccountId></Header></node></root>`,
      ProductStorageXml:
        "<Products><Product><ProductId>undefined</ProductId><MinParQty>0</MinParQty><MinParUOMId>undefined</MinParUOMId><StorageIds>0</StorageIds></Product></Products>",
      AccountId: productData[i].AccountId,
      LocationId: productData[i].LocationId,
      LocationStorageIds: productData[i].LocationStorageIds,
      IsActive: 1,
      InventoryCheckId: productData[i].InventoryCheckId,
    }
    const res = await post(ApiUrls().UPDATE_INVENTORY_FOR_OFFLINE, payload)
    if (res?.status === 200) {
      console.log("success")
      removeAllProducts(productData[i].ProductName)
    } else {
      console.log("Something went wrong while updating the product")
    }
  }
  localStorage.setItem("isofflinelocproductsadded", true)
  getPreviousQuantity();
};

export const saveAccountProductOffline = (productObject) => {
  return addSingleAccountProduct(productObject)
}
export const updateAccountProductOffline = (productObject) => {
  const key = productObject.AccountId
  return updateAccountProduct(key, productObject)
}
export const getAccountProductOffline = (id) => {
  return getSingleAccountProduct(id).then((res) => {
    if (res) {
      return res
    } else {
      return null
    }
  }).catch(() => { return null })
}
export const getAllAccountProductOffline = () => {
  return getAllOfTable('AccountProducts')
}

const removeAllGivenLeads = (leadList) => {
  return removeAllProducts(leadList)
}
export const deleteLeads = (leadList) => {
  return removeAllGivenLeads(leadList);
}


